export default __webpack_public_path__ + "static/media/digitalcard_receipt.128702a5.svg";